/**
 * Styled Components - Created by david on 03/04/18.
 */
import styled from 'styled-components'
import MenuAntd from 'antd/lib/menu'
import { BLUE, GRAY_DARK, GRAY_LIGHTEST, RED, WHITE } from '../../../theme/colors'
const { SubMenu } = MenuAntd

interface DivProps {
  withBorder?: boolean
}

export const Container = styled.div``

export const Text = styled.div`
  color: #fff;
`

export const LoginButton = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const Bottom = styled.div``

export const BottomDiv = styled.div`
  @media (max-width: 1099px) {
    border-top: solid 1px #f1f0ef;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 6px;
    font-weight: bold;
  }
`

export const SelectAll = styled(BottomDiv)`
  @media (max-width: 1099px) {
    font-weight: normal;
  }
`

export const StyledSubMenu = styled(SubMenu)`
  border-bottom: 1px solid ${GRAY_LIGHTEST};
  .ant-menu-submenu-title {
    padding-left: 6px !important;
    padding-right: 2px;
    width: 100%;
  }
  .ant-menu-submenu-arrow {
    right: 12px;
  }
`

export const BetaLabel = styled.div`
  display: inline-block;
  font-size: 9px;
  color: #40ab6d;
  font-style: italic;
  margin-left: 4px;
  vertical-align: top;
  margin-top: -2px;
  font-weight: bold;
  top: 28px;
  right: 22px;
  position: absolute;
`

export const NewLabel = styled.div`
  display: inline-block;
  font-size: 9px;
  color: ${RED};
  font-style: italic;
  margin-left: 4px;
  vertical-align: top;
  margin-top: -2px;
  font-weight: bold;
`

export const Item = styled(MenuAntd.Item)`
  width: 100%;
  padding: 0 6px !important;
  text-transform: ${({ withBorder }: DivProps) => withBorder ? `uppercase` : 'capitalize'};
  border-bottom: ${({ withBorder }: DivProps) => withBorder ? `1px solid ${GRAY_LIGHTEST}` : 'none'};
`

export const TitleSub = styled.div`
  display: flex;
  align-items: center;
`

export const SubItemCategory = styled.div`
  padding: 0 10px !important;
  color: ${BLUE};
  margin: 0 !important;
  border: 1px solid ${BLUE};
  width: fit-content !important;
  height: fit-content !important;
  line-height: 1.75 !important;
  border-radius: 3px;
  font-size: 12px !important;
  margin-left: 30px !important;
  margin-top: 0px !important;
  &.bottom {
    margin-left: 4px !important;
    margin-top: 8px !important;
  }
  &:hover {
    background: ${BLUE};
    color: ${WHITE};
  }
  animation: fade-in-lefttitle 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-lefttitle {
    0% {
      transform: translateX(-10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const SubItem = styled(MenuAntd.Item)`
  width: 100%;
  padding: 0 6px !important;
  text-transform: ${({ withBorder }: DivProps) => withBorder ? `uppercase` : 'capitalize'};
  border-bottom: ${({ withBorder }: DivProps) => withBorder ? `1px solid ${GRAY_LIGHTEST}` : 'none'};
  &::before {
    content: "•";
    color: #bfbfbf63;
    margin-right: 12px;
  }
`

export const SeeAllItem = styled(Item)`
  font-weight: 500;
  font-family: Avenir;
`

export const containerStyle = { height: 'auto' }

export const menuStyle = { width: '100%', overflowX: 'hidden' }

export const ManagerSection = styled.div`
  width: 100%;
  font-weight: normal;
  text-transform: none;
  line-height: normal;
  text-align: left;
  margin-top: 4px;
  margin-bottom: 6px;
  font-size: 12px;
  margin-left: 6px;
`

export const ManagerDiv = styled.div`
  display: flex;
  margin-bottom: 6px;
  flex-wrap: wrap;
`

export const ManagerValue = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin-left: 6px;
  color: ${GRAY_DARK};
`

export const ManagerDirect = styled.div``

export const PhoneManager = styled.a`
  color: ${BLUE};
  font-weight: bold;
  font-family: Avenir;
  margin-left: 6px;
`

export const EmailDiv = styled.div`
  width: 100%;
  margin-top: 2px;
`

export const EmailManager = styled.a`
  color: ${BLUE};
  margin-left: 6px;
`

export const MenuGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 22px;
`

export const GalleryItem = styled.div`
  display: flex;
  flex-flow: column;
  max-width: calc((100% / 3) - 14px);
  margin-left: 7px;
  margin-right: 7px;
  padding: 10px 0px;
  box-shadow: 1px 3px 7px 0px #e8e8e8;
  border-radius: 5px;
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`

export const GalleryIcon = styled.img`
  max-width: 28px;
  max-height: 28px;
  margin-bottom: 12px;
  opacity: 0.8;
`

export const GalleryTitle = styled.div`
  font-family: Avenir;
  font-size: 12px;
  text-align: center;
`

export const LabelCollection = styled.div`
  font-weight: bold;
  font-family: Avenir;
  font-size: 18px;
  &.bottom {
    margin-top: 8px;
    border-top: 4px solid #f2f2f2;
    padding-top: 12px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MobileMenu/Menu/styledComponents.tsx